import React from 'react';
import {getJwt} from '../../../services/authService';
import InfoCircle from '../../common/InfoCircle';
import {teams_data} from "../../constants/constants";
import $ from 'jquery';
import {Link, NavLink} from 'react-router-dom';
import * as authService from "../../../services/authService";
import http from "../../../services/httpService";
import {Classes, Intent, Tooltip, PopoverInteractionKind, Position, Popover} from "@blueprintjs/core";

import toastr from "toastr";
import InviteAdminsModal from '../../modals/InviteAdminsModal';
import TeamsModals from '../../modals/TeamsModals';
import UpsellModalTailwind from "../../modals/UpsellModalTailwind";

class TeamsFeed extends React.Component {
    constructor(props) {
        //console.log("Teams teams_data", teams_data);
        super(props);
        this.state = {
            done: false,
            clicked_id: "",
            clicked_feed_id: "",
            clicked_index: "",
            clicked_feed_index: "",
            data: {
                feeds_shared: [],
                team: [],
                feeds_admins: []
            },
            team: '',
            feed: '',
            listOfAdmins: [],
            errors: {},
            display: "none",
            opacity: "0",
            displayForFeed: "none",
            source_id: "",
            addProjectAdminModalVisible: false,
            removeAdminFromProjectModalVisible: false,
            removeAdminFromTeamModalVisible: false,
            limitsReached: '',
            user: this.props.user,
            upsellModalVisible: false,
            upgradeModalTitle: '',
            upgradeModalContent: ''
        };
    }

    toggleMemberData = (e) => {
        this.setState({
            clicked_id: e.target.id,
            clicked_index: e.target.name || e.target.title
        });
        if (this.state.display === "none") {
            this.setState({display: "block", opacity: '1'});
        } else {
            this.setState({display: "none", opacity: '0'})
        }
    };

    toggleFeedMemberData = (e) => {
        //console.log("toggleMemberData e.target", e.target);
        this.setState({
            clicked_feed_id: e.target.id,
            clicked_feed_index: e.target.name || e.target.title
        });
        if (this.state.displayForFeed === "none") {
            this.setState({displayForFeed: "block", opacity: 1});
        } else {
            this.setState({displayForFeed: "none", opacity: 0})
        }
    };

    handleTeamEdit = (e) => {
        if (e.target.slot) {
            const targetFade = '#' + e.target.slot;
            //console.log("handleTeamEdit TeamsFeed,targetFade",targetFade);
            $(targetFade).fadeToggle();
        }
        //$(this).toggleClass('opened');
        //$('.team-edit .platform-dropdown').fadeToggle();
    };


    openDescription = (e) => {
        const descPanel = e.target.nextSibling;
        if (descPanel.classList.contains('d-block')) {

            descPanel.classList.remove('d-block');
        } else {
            descPanel.classList.add('d-block');


        }

    };
    closeDescription = (e) => {
        const descPanel = e.target.parentElement;
        if (descPanel.classList.contains('d-block')) {

            descPanel.classList.remove('d-block');
        } else {
            descPanel.classList.add('d-block');


        }
    };

    addDefaultSrc = (ev) => {
        ev.target.src = 'https://4.bp.blogspot.com/-zsbDeAUd8aY/US7F0ta5d9I/AAAAAAAAEKY/UL2AAhHj6J8/s640/facebook-default-no-profile-pic.jpg';
    }

    getTeams = async () => {
        try {
            const result = await http.get('api/user/' + authService.getCurrentUserId() + '/teams', {headers: {authorization: getJwt()}});
            // console.log("componentDidMount result", result);
            const data = result.data;

            //console.info("DATA RESP", data);

            if (!data) {
                toastr.error("User ID does not match.  Please log in again.");
                this.props.history.push('/logout');
            }
            // this.setState({data: data});
            if (data.teams) {
                this.props.appPropagateTeams(data);
                await this.setState({})

            }
        } catch (e) {
            toastr.error('Error with loading Teams')
        }

    }
    updateWorkspaceData = async () => {
        //console.log('update workspace data')
        const source_id = this.props.source && this.props.source.id ? this.props.source.id :
            this.props.source && this.props.source.project_id ? this.props.source.project_id :
                localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        if (source_id) {
            const result = await http.get('api/user/feed/' + source_id + '/teams', {headers: {authorization: getJwt()}});
            const data = await result.data;

            //console.info("DATA RESP", data);
            if (!data) {
                //toastr.error("User id does not match. :(  Please log in again.");
                this.props.history.push('/logout');
            }


            this.setState({data: data, source_id});

            const team = await data.team.data ? await data.team.data[0] : {};
            if (team && team !== this.state.team) {
                let feed = await team.feeds.find((feed) => feed.id.toString() === source_id.toString());
                await this.setState({
                    team,
                    feed,
                    source_id
                })

            }
        }

    }
    componentDidMount = () => {
        this.updateWorkspaceData()
        this.checkLimitations()
    }

    checkLimitations = () => {
        let limitsReached = []
        if (this.state.data.team.data) {
            this.state.data.team.data.map(team => {
                    // console.log('team: ', team)
                    let teamData = {
                        id: team.id,
                        name: team.team_name,
                        teamMemberCount: '',
                        teamMemberMax: '',
                        teamLimitReached: false,
                        workspaces: []
                    }
                    //for adding team member purposes
                    let teamAdminCount = team.admins.length + team.pending_admins.length
                    let workspacesAdminsCount = 0


                    //console.log('teamAdminCount1: ', teamAdminCount)
                    let fullWorkspacesInTeam = []

                    //CREATING ARRAY WITH FULL DATA OF ALL WORKSPACES IN THIS TEAM
                    // console.log('this.state.user.sources.data: ', this.state.user.sources.data)
                    // console.log('team.feeds: ', team.feeds)
                    if (this.state.user && this.state.user.sources) {
                        //console.log('there are sources')
                        team.feeds.map(teamFeed => {
                            workspacesAdminsCount = workspacesAdminsCount + teamFeed.admins.length + teamFeed.pending_admins.length
                            let teamFound = this.state.user.sources.data.find(userSource => {
                                return userSource.name === teamFeed.name
                            })
                            if (teamFound){
                                fullWorkspacesInTeam.push(teamFound)
                            }
                        })
                        // console.log('workspacesAdminsCount: ', workspacesAdminsCount)
                        //console.log('fullWorkspacesInTeam: ', fullWorkspacesInTeam)

                        teamAdminCount = teamAdminCount + workspacesAdminsCount
                        //console.log('finalTeamAdminCount: ', teamAdminCount)
                        //
                        let unlimitedCheckTeam = ''
                        if (fullWorkspacesInTeam.length > 0) {
                            //console.log('there is data')
                            unlimitedCheckTeam = fullWorkspacesInTeam.find(userSource => {
                                //console.log('userSource: ', userSource)
                                if (userSource && userSource.plan && userSource.plan.additional_features && userSource.plan.additional_features.team_members) {
                                    if (userSource.use_custom_plan === 1) {
                                        return (userSource.custom_plan.additional_features.team_members === "Unlimited")
                                    } else {
                                        return userSource.plan.additional_features.team_members === "Unlimited"
                                    }
                                }
                            })
                            //console.log('check if workspace has unlimited unlimitedCheckTeam: ', unlimitedCheckTeam)
                            unlimitedCheckTeam = unlimitedCheckTeam !== undefined
                        } else {
                            unlimitedCheckTeam = false
                        }

                        //console.log('unlimitedCheckTeam: ', unlimitedCheckTeam)


                        //TEAM LIMITATIONS HANDLING
                        let maxAdminsInTeam,
                            teamLimitReached
                        if (unlimitedCheckTeam) {

                            maxAdminsInTeam = 'Unlimited'
                            teamLimitReached = false
                        } else {

                            let arrayOfMaxAdmins = fullWorkspacesInTeam.map(fullWorkspaceInTeam => {
                                //console.log('fullWorkspaceInTeam.plan.additional_features.team_members: ', fullWorkspaceInTeam.plan.additional_features.team_members)
                                
                                if (fullWorkspaceInTeam && fullWorkspaceInTeam.use_custom_plan && fullWorkspaceInTeam.custom_plan.additional_features && fullWorkspaceInTeam.use_custom_plan === 1) {
                                    return Number(fullWorkspaceInTeam.custom_plan.additional_features.team_members)
                                } else if(fullWorkspaceInTeam.plan && fullWorkspaceInTeam.plan.additional_features && fullWorkspaceInTeam.plan.additional_features.team_members) {
                                    return Number(fullWorkspaceInTeam.plan.additional_features.team_members)
                                }
                            })
                            //console.log('arrayOfMaxAdmins: ', arrayOfMaxAdmins)
                            maxAdminsInTeam = Math.max(...arrayOfMaxAdmins)
                            teamLimitReached = maxAdminsInTeam <= teamAdminCount
                        }

                        teamData.teamAdminCount = teamAdminCount
                        teamData.teamAdminMax = maxAdminsInTeam
                        teamData.teamLimitReached = teamLimitReached

                        let workspaces = []
                        let workspace = {
                            name: '',
                            workspaceMaxAdmins: '',
                            workspaceAdminsCount: '',
                            workspaceLimitReached: '',
                        }
                        if (fullWorkspacesInTeam) {
                            // console.log('fullWorkspacesInTeam: ', fullWorkspacesInTeam)
                            fullWorkspacesInTeam.map(fullWorkspace => {
                                // console.log('fullWorkspace: ', fullWorkspace)
                                let workspaceInTeam = team.feeds.find(feed => {
                                    return feed.id === fullWorkspace.id
                                })
                                //console.log('workspaceInTeam: ', workspaceInTeam)

                                let workspaceMaxAdmins = fullWorkspace.plan && fullWorkspace.plan.additional_features && fullWorkspace.plan.additional_features.team_members ?
                                    fullWorkspace.plan.additional_features.team_members === 'Unlimited' ? 'Unlimited' : 
                                        fullWorkspace.use_custom_plan === 1 ?
                                            Number(fullWorkspace.custom_plan.additional_features.team_members)
                                            :
                                            Number(fullWorkspace.plan.additional_features.team_members)
                                        :
                                        0;
                                        
                                let workspaceAdminsCount = workspaceInTeam.admins.length + workspaceInTeam.pending_admins.length + team.admins.length + team.pending_admins.length
                                let workspaceLimitReached

                                if (workspaceMaxAdmins === 'Unlimited') {
                                    workspaceLimitReached = false
                                } else {
                                    workspaceLimitReached = workspaceAdminsCount >= workspaceMaxAdmins
                                }

                                workspaces.push(
                                    {
                                        id: fullWorkspace.id,
                                        name: fullWorkspace.name,
                                        workspaceLimitReached: workspaceLimitReached,
                                        workspaceMaxAdmins: workspaceMaxAdmins,
                                        workspaceAdminsCount: workspaceAdminsCount,
                                    }
                                )
                            })

                        }
                        teamData.workspaces = workspaces

                        limitsReached = [...limitsReached, teamData]
                    }
                }
            )

        }
        //console.log('limitsReached: ', limitsReached)
        this.setState({
            limitsReached
        })
    }

    componentDidUpdate = async () => {
        const source_id = this.props.source && this.props.source.id ? this.props.source.id :
            this.props.source && this.props.source.project_id ? this.props.source.project_id :
                localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        // if (this.state.data.teams !== this.props.teams) {
        //
        //     console.info('this.props.teams: ', this.props.teams)
        //     console.info('calling teams')
        //     this.getTeams()
        //
        // }
        if (this.state.source_id !== source_id) {
            //console.info('source id changed')


            if (source_id) {
                const result = await http.get('api/user/feed/' + source_id + '/teams', {headers: {authorization: getJwt()}});
                const data = await result.data;

                //console.info("DATA RESP", data);
                if (!data) {
                    //toastr.error("User id does not match. :(  Please log in again.");
                    this.props.history.push('/logout');
                }


                this.setState({data: data, source_id});

                const team = await data.team.data ? await data.team.data[0] : {};
                if (team && team !== this.state.team) {
                    let feed = await team.feeds.find((feed) => feed.id.toString() === source_id.toString());
                    await this.setState({
                        team,
                        feed,
                        source_id
                    })
                }
            }
            this.setState({
                source_id: source_id
            })
            this.checkLimitations()

        }
        if (this.state.user !== this.props.user) {
            this.setState({
                user: this.props.user
            })
        }
    }

    addProjectAdmin = (workspaceId) => {
        //console.log('workspaceId: ', workspaceId)

        let workspaceLimitations = this.state.limitsReached[0].workspaces.find(workspace => {
            return workspace.id === workspaceId
        })

        let workspaceLimitReached = workspaceLimitations.workspaceLimitReached

        if (workspaceLimitReached) {
            this.setState({
                upsellModalVisible: true,
                upgradeModalTitle: 'You reached limited number of users on "' + workspaceLimitations.name + '" workspace',
                upgradeModalContent: 'Check out the plans and features below and choose the one that suits your needs.'
            })
        } else {
            this.setState({
                addProjectAdminModalVisible: true

            })
        }
        //console.log('workspaceLimitations: ', workspaceLimitations)
    }

    render() {
        //console.log(this.state.data);
        const team_data = this.state.data;
        const feeds_admins = this.state.data.feeds_admins;
        const {clicked_id, clicked_index, clicked_feed_id, clicked_feed_index} = this.state;
        const team = this.state.team;
        const feed = this.state.feed;
        return (
            <React.Fragment>
                {team ?
                    <div className="team-card project-settings-info-card">
                        <div className="team-header">
                            <h3>{team.team_name}</h3>
                            <Link to='/teams'>
                                <div className='add-team-admin add-new workspace-tour-step-5'
                                    // onClick={(e) => {
                                    //     e.preventDefault();
                                    //     window.location.href = '/teams';
                                    // }}
                                >
                                    Manage team
                                </div>
                            </Link>
                        </div>
                        <div className="team-body" data-intercom-target="teams-feed-team-body">
                            <div className="team-admins workspace-tour-step-4">
                                <div className="admins-header-container">
                                    <div className='admins-subtitle'>
                                        <span className="team-subtitle">Team Admins</span>
                                        <InfoCircle
                                            icon='question'
                                            infoCircleContent={
                                                <p className='info-circle-content'><strong>Team Admins</strong> <br/>
                                                    Can manage all workspaces within a team.</p>
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="separator"></div>

                                <div className="row">
                                    <div className="col-xs-12">
                                        {team.admins.map((admin, index) =>

                                            <div key={index} id={index} className="team-user"
                                                 onClick={this.toggleMemberData}>


                                                <div id={admin.id}
                                                     title={admin.first_name + " " + admin.last_name}
                                                     className="team-user-panel">

                                                    <div className="team-admin-pic">
                                                        <img src={admin.profile_photo || "/img/default-user.jpg"}
                                                             alt="user"
                                                             onError={this.addDefaultSrc}/>
                                                    </div>
                                                    <div className="team-admin-about">
                                                        <div
                                                            className="team-user-name">{(admin.first_name || '') + " " + (admin.last_name || '')}</div>
                                                        <div className="team-user-email">{admin.email}</div>
                                                    </div>
                                                </div>
                                                <div className="platform-menu feed-edit">
                                                    {/*<Popover*/}
                                                    {/*    interactionKind={PopoverInteractionKind.CLICK}*/}
                                                    {/*    position={Position.LEFT_TOP}*/}
                                                    {/*    minimal={true}*/}
                                                    {/*>*/}

                                                    {/*    <span className="fas fa-ellipsis-v"></span>*/}
                                                    {/*    <div*/}
                                                    {/*        className={this.state.removeAdminFromProjectModalVisible ? 'd-none' : ''}*/}
                                                    {/*    >*/}
                                                    {/*        <div className="three-dots-popover padding-10">*/}
                                                    {/*            {team.admins.length === 1 ?*/}
                                                    {/*                <a id="team_delete_btn"*/}
                                                    {/*                   onClick={() => toastr.info("You can't delete the last admin from the team. " +*/}
                                                    {/*                       "You can either delete the whole team or add a new admin and then delete yourself.")}*/}
                                                    {/*                   href="#">Remove from team</a>*/}
                                                    {/*                :*/}
                                                    {/*                <a id="team_delete_btn" title={team.id}*/}
                                                    {/*                   name={admin.id}*/}
                                                    {/*                   slot={(admin.first_name || '') + " " + (admin.last_name || '')}*/}
                                                    {/*                   onClick={() => this.setState({*/}
                                                    {/*                       removeAdminFromProjectModalVisible: true,*/}
                                                    {/*                       selectedAdmin: admin,*/}
                                                    {/*                       isPendingAdmin: false*/}
                                                    {/*                   })}*/}
                                                    {/*                   href="#">Remove from team</a>*/}
                                                    {/*            }*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</Popover>*/}
                                                </div>
                                            </div>
                                        )}
                                        {team.pending_admins && team.pending_admins.map((pending_admin, index) =>

                                            <div id={pending_admin.id} key={index} className="team-user"
                                                 onClick={this.toggleMemberData}>


                                                <div className="team-user-panel reg-pending-panel">
                                                    <span className="pending-reg"></span>
                                                    <div className="team-admin-about">
                                                        <div
                                                            className="team-user-name">{pending_admin.name || pending_admin.email}</div>
                                                        <div className="team-user-email">Registration pending</div>
                                                    </div>
                                                </div>

                                                <div className="platform-menu feed-edit ">
                                                    {/*<Popover*/}
                                                    {/*    interactionKind={PopoverInteractionKind.CLICK}*/}
                                                    {/*    className={this.state.removeAdminFromTeamModalVisible ? 'd-none' : ''}*/}

                                                    {/*    position={Position.LEFT_TOP}*/}
                                                    {/*    minimal={true}*/}
                                                    {/*>*/}
                                                    {/*    <span className="fas fa-ellipsis-v"></span>*/}
                                                    {/*    <div*/}
                                                    {/*        className={this.state.removeAdminFromTeamModalVisible ? 'd-none' : ''}*/}

                                                    {/*    >*/}
                                                    {/*        <div className="three-dots-popover padding-10">*/}
                                                    {/*            <a href="#" title={team.id}*/}
                                                    {/*               name={pending_admin.id}*/}
                                                    {/*               slot={pending_admin.email}*/}
                                                    {/*               id="remove_pending_from_team"*/}

                                                    {/*               onClick={() => this.setState({*/}
                                                    {/*                   removeAdminFromProjectModalVisible: true,*/}
                                                    {/*                   selectedAdmin: pending_admin,*/}
                                                    {/*                   isPendingAdmin: true*/}
                                                    {/*               })}>Remove from team</a>*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</Popover>*/}
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>

                            {/*project admins*/}

                            <div className="team-admins workspace-tour-step-2">
                                <div className="admins-header-container">
                                    <div className='admins-subtitle'>
                                        <span className="team-subtitle">Workspace Admins</span>
                                        <InfoCircle
                                            icon='question'
                                            infoCircleContent={
                                                <p className='info-circle-content'><strong>Workspace Admins</strong>
                                                    <br/>
                                                    Can manage only workspaces they are assigned on.</p>
                                            }
                                        />
                                    </div>


                                    <a href="#" id="add_admin_spec_feed"
                                       slot={feed.id}
                                       title={feed.name}
                                       onClick={
                                           () => this.addProjectAdmin(feed.id)
                                       }
                                       className="add-new workspace-tour-step-3">
                                        + Add workspace admin
                                    </a>


                                </div>
                                <div className="separator"></div>
                                <div className="row">
                                    {feed ?
                                        <div className="col-xs-12">
                                            {this.state.feed.admins.map((admin, index) =>
                                                <div key={index} id={index} className="team-user"
                                                     onClick={this.toggleMemberData}>


                                                    <div id={admin.id}
                                                         title={admin.first_name + " " + admin.last_name}
                                                         className="team-user-panel ">

                                                        <div className="team-admin-pic">
                                                            <img src={admin.profile_photo || "/img/default-user.jpg"}
                                                                 alt="user"
                                                                 onError={this.addDefaultSrc}/>
                                                        </div>
                                                        <div className="team-admin-about">
                                                            <div
                                                                className="team-user-name">{(admin.first_name || '') + " " + (admin.last_name || '')}</div>
                                                            <div className="team-user-email">{admin.email}</div>
                                                        </div>
                                                    </div>
                                                    <div className="platform-menu feed-edit">
                                                        <Popover
                                                            interactionKind={PopoverInteractionKind.CLICK}

                                                            position={Position.LEFT_TOP}
                                                            minimal={true}
                                                        >

                                                            <span className="fas fa-ellipsis-v"></span>

                                                            <div className="three-dots-popover padding-10">
                                                                {/*{team.admins.length === 1 ?*/}
                                                                {/*    <a id="team_delete_btn"*/}
                                                                {/*       onClick={() => toastr.info("You can't delete the last admin from the team. " +*/}
                                                                {/*           "You can either delete the whole team or add a new admin and then delete yourself.")}*/}
                                                                {/*       href="#">Remove from workspace</a>*/}
                                                                {/*    :*/}
                                                                <a id="team_delete_btn" title={team.id}
                                                                   name={admin.id}
                                                                   slot={(admin.first_name || '') + " " + (admin.last_name || '')}
                                                                   onClick={() => this.setState({
                                                                       removeAdminFromProjectModalVisible: true,
                                                                       selectedAdmin: admin,
                                                                       isPendingAdmin: false
                                                                   })}
                                                                   href="#">Remove from workspace</a>
                                                                {/*}*/}
                                                            </div>
                                                        </Popover>
                                                    </div>
                                                </div>
                                            )}
                                            {this.state.feed.pending_admins.map((pending_admin, index) =>

                                                <div id={pending_admin.id} key={index} className="team-user"
                                                     onClick={this.toggleMemberData}>


                                                    <div className="team-user-panel reg-pending-panel">
                                                        <span className="pending-reg"></span>
                                                        <div className="team-admin-about">
                                                            <div
                                                                className="team-user-name">{pending_admin.name || pending_admin.email}</div>
                                                            <div className="team-user-email">Registration pending</div>
                                                        </div>
                                                    </div>

                                                    <div className="platform-menu feed-edit ">
                                                        <Popover
                                                            interactionKind={PopoverInteractionKind.CLICK}

                                                            position={Position.LEFT_TOP}
                                                            minimal={true}
                                                        >
                                                            <span className="fas fa-ellipsis-v"></span>
                                                            <div className="three-dots-popover padding-10">
                                                                <a href="#" title={team.id}
                                                                   name={pending_admin.id}
                                                                   slot={pending_admin.email}
                                                                   id="remove_pending_from_team"

                                                                   onClick={() => {
                                                                       // console.log('clicked')
                                                                       this.setState({
                                                                           removeAdminFromProjectModalVisible: true,
                                                                           selectedAdmin: pending_admin,
                                                                           isPendingAdmin: true
                                                                       })
                                                                   }}>Remove from workspace</a>
                                                            </div>
                                                        </Popover>
                                                    </div>
                                                </div>
                                            )}
                                            {/*{console.log('feed admins data: ', feed, this.state.isPendingAdmin, this.state.selectedAdmin,*/}
                                            {/*this.state.removeAdminFromProjectModalVisible, this.state.removeAdminFromTeamModalVisible)}*/}
                                            {
                                                /* Here remove only user.email !== */
                                                !this.state.feed.admins.length && !this.state.feed.pending_admins.length && this.props.user.user_type !== 'reseller' ?
                                                    (this.props.selectedSourceNode && this.props.selectedSourceNode.plan &&
                                                        this.props.selectedSourceNode.plan.team_members && this.props.selectedSourceNode.plan.team_members === '1') ||
                                                    (this.props.selectedSourceNode && this.props.selectedSourceNode.plan &&
                                                        this.props.selectedSourceNode.plan.team_members &&
                                                        this.props.selectedSourceNode.plan.team_members === '5' &&
                                                        (this.state.feed.admins.length + this.state.feed.pending_admins.length) > 3) ?
                                                        <Popover
                                                            interactionKind={PopoverInteractionKind.CLICK}

                                                            position={Position.CENTER}
                                                            minimal={true}
                                                        >
                                                            <div
                                                                className="add-new-teammate-button"
                                                                disabled={true}
                                                            >
                                                                <span className="admin-icon fas fa-user-plus"></span>
                                                                <span>Add your new Teammate</span>
                                                            </div>
                                                            <p className='padding-10'>You reached maximum team members
                                                                for current plan.</p>
                                                        </Popover>
                                                        :
                                                        <div
                                                            className="add-new-teammate-button"
                                                            onClick={() => this.setState({addProjectAdminModalVisible: true})}
                                                        >
                                                            <span className="admin-icon fas fa-user-plus"></span>
                                                            <span>Add your new Teammate</span>
                                                        </div>
                                                    :
                                                    (this.props.user.user_type === 'reseller') &&
                                                    ((this.state.feed.admins.length + this.state.feed.pending_admins.length) > 0) ?
                                                        <Popover
                                                            interactionKind={PopoverInteractionKind.CLICK}

                                                            position={Position.CENTER}
                                                            minimal={true}
                                                        >
                                                            <div
                                                                className="add-new-teammate-button"
                                                                disabled={true}
                                                            >
                                                                <span className="admin-icon fas fa-user-plus"></span>
                                                                <span>Add your new Teammate</span>
                                                            </div>
                                                            <p className='padding-10'>You reached maximum team members
                                                                for current plan.</p>
                                                        </Popover>
                                                        :
                                                        (this.props.user.user_type === 'reseller') &&
                                                        ((this.state.feed.admins.length + this.state.feed.pending_admins.length) === 0) ?
                                                            <div
                                                                className="add-new-teammate-button"
                                                                onClick={() => this.setState({addProjectAdminModalVisible: true})}
                                                            >
                                                                <span className="admin-icon fas fa-user-plus"></span>
                                                                <span>Add your new Teammate</span>
                                                            </div>
                                                            :
                                                            ''

                                            }

                                        </div> : ''
                                    }
                                </div>
                            </div>

                        </div>
                    </div>


                    : ''
                }


                <InviteAdminsModal
                    showModal={this.state.addProjectAdminModalVisible}
                    type={'projectAdmin'}
                    width={500}
                    handleClose={() => this.setState({addProjectAdminModalVisible: false})}
                    history={this.props.history}
                    team_name={team.team_name}
                    team_id={team.id}
                    projectId={feed ? feed.id ? feed.id : feed.project_id ? feed.project_id : '' : ''}
                    project_name={feed && feed.name ? feed.name : ''}
                    user={this.props.user}
                    getTeams={this.getTeams}
                    updateWorkspaceData={this.updateWorkspaceData}

                />
                <TeamsModals
                    showModal={this.state.removeAdminFromProjectModalVisible}
                    type={'removeAdminFromProject'}
                    width={500}
                    handleClose={async () => {
                        await this.setState({removeAdminFromProjectModalVisible: false})
                        await this.props.updateUserFromServer();
                        await this.getTeams();
                    }}
                    history={this.props.history}
                    team_name={team.team_name}
                    team_id={team.id}
                    project_id={feed ? feed.id ? feed.id : feed.project_id ? feed.project_id : '' : ''}
                    project_name={feed && feed.name ? feed.name : ''}
                    selectedAdmin={this.state.selectedAdmin || ''}
                    isPendingAdmin={this.state.isPendingAdmin}
                    user={this.props.user}
                    getTeams={this.getTeams}
                    updateWorkspaceData={this.updateWorkspaceData}
                />
                <UpsellModalTailwind
                    selectedSource={this.state.source_id}
                    showModal={this.state.upsellModalVisible}
                    handleClose={() => this.setState({upsellModalVisible: false})}
                    maxWidth={null}
                    history={this.props.history}
                    title={this.state.upgradeModalTitle}
                    content={this.state.upgradeModalContent}
                    plan={this.state.selectedPlan}
                    user={this.props.user}
                />
            </React.Fragment>

        )
    }

}

export default TeamsFeed